import { render, staticRenderFns } from "./PaymentMethodManager.vue?vue&type=template&id=4563751a&scoped=true&"
import script from "./PaymentMethodManager.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodManager.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodManager.vue?vue&type=style&index=0&id=4563751a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4563751a",
  null
  
)

export default component.exports